import { useApp } from '~/modules/app'

import { GaButton } from '~/components/button'

import { useCaptureError } from './scripts/composables/capture-error'

// @vue/component
export default {
  name: 'ga-app-error',

  components: { GaButton },

  props: {
    external: {
      type: Boolean,
      default: false,
    },
    code: {
      type: Number,
      required: true,
    },
    error: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    const { $gaApp } = useNuxtApp()

    const { appWithHover } = useApp()

    const isDesktop = computed(() => $gaApp.mq('desktop-small+'))

    const openSearchModal = () => {}

    const { captureError } = useCaptureError({
      code: props.code,
      error: props.error,
    })

    const maxCountMedia = computed(() => (unref(appWithHover) ? 10 : 1))

    const onRefreshClick = () => {
      window.location.reload()
    }

    onMounted(() => {
      console.error(props.error)

      captureError()
    })

    return {
      maxCountMedia,
      onRefreshClick,

      isDesktop,
      openSearchModal,
    }
  },
}
